export var EXPANDER_COLUMN_ID = 'expander';
export var CAMPAIGN_COLUMN_ID = 'campaign';
export var AUDIENCE_COLUMN_ID = 'audience';
export var OPEN_RATE_COLUMN_ID = 'openRate';
export var FREQUENCY_COLUMN_ID = 'frequency';
export var TOGGLE_COLUMN_ID = 'toggle';
export var ACTIONS_COLUMN_ID = 'actions';
